import TooltippsBadges from "../../99-libs/tooltipps-badges";

("use strict");

let wrapper = document.querySelector(".products-list");
let primaryCategorySelector = null;
let secondaryCategorySelector = null;

let templates = {};

let layoutView = "list";

let productsCount = 0;
let partsCount = 0;

const tooltipps = new TooltippsBadges();

function initializeSearch() {
  wrapper = document.querySelector(".products-list");
  if (!wrapper) return;

  templates = {
    container: document.querySelector("#container-template"),
    product: document.querySelector("#product-template"),
    firstBadge: document.querySelector("#first-badge-template"),
    AdditionalBadge: document.querySelector("#additional-badge-template"),
  };

  const layoutRadio = document.querySelectorAll(
    "input[type=radio][name=layout]"
  );

  if (layoutRadio.length) {
    layoutRadio.forEach((radio) => {
      radio.addEventListener("change", () => {
        setCookie(
          "layout",
          document.querySelector('input[name="layout"]:checked').value,
          30
        );
        if (radio.value == "grid") {
          wrapper.classList.remove("products-list__list-layout");
          wrapper.classList.add("products-list__grid-layout");
        } else {
          wrapper.classList.remove("products-list__grid-layout");
          wrapper.classList.add("products-list__list-layout");
        }
      });
    });
  }

  const layoutChange = document.querySelectorAll(
    ".products-filter__layouts input"
  );
  if (layoutChange.length) {
    layoutChange.forEach((radio) => {
      radio.addEventListener("change", () => {
        layoutView = radio.value;
        changeLayout();
        updateCookie();
      });
    });
  }

  setInitialState();
  tooltipps.init();
}

function setInitialState() {
  const cookieValue = getCookie("layout");
  if (cookieValue) {
    layoutView = cookieValue;
  }
  if (layoutView) {
    document.querySelector(
      'input[name="layout"][value="' + layoutView + '"]'
    ).checked = true;
  }
  changeLayout();
}

function changeLayout() {
  if (layoutView == "list") {
    wrapper.classList.remove("products-list__grid-layout");
    wrapper.classList.add("products-list__list-layout");
  }
  if (layoutView == "grid") {
    wrapper.classList.remove("products-list__list-layout");
    wrapper.classList.add("products-list__grid-layout");
  }
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function updateCookie() {
  setCookie(
    "layout",
    document.querySelector('input[name="layout"]:checked').value,
    30
  );
}

export default initializeSearch;
